module.exports = __webpack_public_path__ + "static/media/screenshot_step3_2_purple.58b5c6dc.svg";